import { BusinessAreaField } from "../../../../enums";
import { IFlightPathApiResponse } from "../BaseApiModel";
import http from "../Http";
import { IFilteredOptions, IFilteredResponse } from "../filteredApi/FilteredApiModel";
import { FilteredOrganisationApiModel } from "../filteredApi/FilteredOrganisationApiModel";
import { AxiosInstance, AxiosRequestConfig } from "axios";

export class BusinessAreasApi extends FilteredOrganisationApiModel<FP.Entities.IBusinessArea> {
  controller: string = "business-areas";

  constructor(http: AxiosInstance) {
    super(http, "business-areas");
  }

  getFilteredAsync = async (
    filterOptions: Partial<IFilteredOptions>,
    config?: AxiosRequestConfig,
    organisationId?: number
  ) => {
    const query = this.getRequestQuery(filterOptions);
    const res = await this.http.get(`${this.url}/${organisationId}/${this.controller}${query}`, config);
    return res.data;
  };

  getRoles = async (
    organisationId: number,
    businessAreaId: number,
    filterOptions?: IFilteredOptions,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IRole[]>> => {
    const url = `${this.url}/${organisationId}/${this.controller}/${businessAreaId}/roles${(filterOptions && this.getRequestQuery(filterOptions)) || ""
      }`;
    let res = await this.http.get(url, config);
    return res.data;
  };

  getHierarchyStakeholders = async (
    organisationId: number,
    businessAreaId: number,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IStakeholder[]>> => {
    const url = `${this.url}/${organisationId}/${this.controller}/${businessAreaId}/stakeholders-tree`;
    let res = await this.http.get(url, config);
    return res.data;
  };

  updateField = async (
    organisationId: number,
    projectId: number = null,
    businessAreaId: number,
    textField: string,
    idField: number,
    dateField: Date,
    numericField: number,
    field: BusinessAreaField,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.ITrainingType>> => {
    let data = {
      TextField: textField,
      IdField: idField,
      DateField: dateField,
      NumericField: numericField
    };
    let res = await this.http.put(
      `${this.url}/${organisationId}/${this.controller}/${businessAreaId}/${field}`,
      data,
      config
    );

    return res.data;
  };

  getAll = async (organisationId: number, config?: any) => {
    let res = await this.http.get(`${this.url}/${organisationId}/${this.controller}`, config);
    return res.data;
  };

  deleteRange = async (organisationId: number, projectId: number, ids: number[], config?: AxiosRequestConfig) => {
    let res = await this.http.post(`${this.url}/${organisationId}/${this.controller}/delete-range`, ids, config);
    return res.data;
  };

  getByName = async (
    organisationId: number,
    name: string,
    config?: AxiosRequestConfig
  ): Promise<IFilteredResponse<any>> => {
    const url = `${this.url}/${organisationId}/${this.controller}/name/${name}`;
    let res = await this.http.get(url, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  createFromUploader = async (
    organisationId: number,
    newBusinessAreas: FP.Entities.IBusinessArea[],
    businessAreasToReplace: FP.Entities.IBusinessArea[],
    config?: AxiosRequestConfig
  ) => {
    let res = await this.http.post(`${this.url}/${organisationId}/${this.controller}/create-from-upload`, {
      newBusinessAreas: newBusinessAreas,
      businessAreasToReplace: businessAreasToReplace
    }, config);
    return res.data;
  }
}

const instance = new BusinessAreasApi(http);

export default instance;
